import { render } from "./facebook-official.vue?vue&type=template&id=61fd1872"
import script from "./facebook-official.vue?vue&type=script&lang=js"
export * from "./facebook-official.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__